import { BorderRadiusTokens, ColorTokens, FontSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SelectiveListItemStateTokens, SizeTypeTokens, TypographyTypeTokens, } from '@voltmoney/schema';
import React, { memo, useEffect, useState, } from 'react';
import ThemeProvider from '@voltmoney/theme';
import Space from '../space/Space';
import Typography from '../typography/Typography';
import Image from '../image/Image';
import { TouchableOpacity, View, } from 'react-native';
import { Icon } from '../icon/Icon';
const SelectiveListItemBase = ({ onPress, title, subTitle, imageUrl, triggerAction, action, state = SelectiveListItemStateTokens.NOT_SELECTED, }) => {
    const theme = ThemeProvider.getTheme();
    const selectiveThemeProps = theme.selectiveListItem[state];
    const [isChecked, setChecked] = useState(state === SelectiveListItemStateTokens.SELECTED);
    const colorsMap = theme.colors;
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction({
                ...action,
                payload: { ...action.payload, value: state },
            });
    };
    useEffect(() => {
        if (state === SelectiveListItemStateTokens.SELECTED) {
            setChecked(true);
        }
        else {
            setChecked(false);
        }
    }, [state]);
    return (React.createElement(TouchableOpacity, { onPress: handleAction, style: {
            borderColor: colorsMap[selectiveThemeProps.borderColor],
            borderWidth: 1,
            flexDirection: 'row',
            paddingTop: 15,
            paddingLeft: 13,
            paddingBottom: 12,
            borderRadius: 4,
            backgroundColor: colorsMap[selectiveThemeProps.bgColor],
        } },
        React.createElement(View, { style: { flexDirection: 'row', flex: 1 } },
            React.createElement(View, { style: { flexDirection: 'column' } },
                React.createElement(View, { style: {
                        height: 4,
                        backgroundColor: `${selectiveThemeProps.bgColor}`,
                    } }),
                React.createElement(Icon, { name: isChecked
                        ? IconTokens.RadioCircleFilled
                        : IconTokens.RadioCircleNotFilled, size: IconSizeTokens.MD })),
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(View, { style: { flexDirection: 'column' } },
                React.createElement(Typography, { label: title, color: ColorTokens.Grey_Night, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 24, paddingTop: 0 }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(Typography, { label: subTitle, type: TypographyTypeTokens.B6, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontWeight: '600', lineHeight: 18, paddingTop: 0 }))),
        React.createElement(View, { style: { flexDirection: 'row' } },
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(Image, { uri: imageUrl, size: ImageSizeTokens.Size_40, borderRadius: BorderRadiusTokens.BR5 }))));
};
export default memo(SelectiveListItemBase);
export { SelectiveListItemBase };
